(function () {
  'use strict';

  var inputSelector = [
    '[data-a11y-modal] input[name="boost-q"]',
    '#boost-pfs-search-box-mobile'
  ].join(',');
  var popupSelector = '.boost-pfs-search-suggestion-wrapper';
  var mobilePanelSelector = '.boost-pfs-search-suggestion-mobile-top-panel';
  var itemSelector = [
    '.boost-pfs-search-suggestion-item',
    '.boost-pfs-search-suggestion-header-view-all'
  ].join(',');

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function getPopup(input) {
    if (!input.id) return null;

    return Array.from(document.querySelectorAll(popupSelector)).find(function (popup) {
      return popup.getAttribute('data-search-box-id') === input.id ||
        popup.id === input.id.replace('search-box', 'search-suggestion');
    }) || null;
  }

  function getOptionLink(option) {
    if (option.matches('a[href]')) return option;
    return option.querySelector('a[href]');
  }

  function getOptions(popup) {
    var options = [];

    popup.querySelectorAll(itemSelector).forEach(function (item) {
      if (!getOptionLink(item)) return;

      var option = item.matches('[role="option"]') ? item :
        item.querySelector('[role="option"]') || item;
      if (options.indexOf(option) === -1) options.push(option);
    });

    return options;
  }

  function syncSemantics(input) {
    setAttribute(input, 'role', 'combobox');
    setAttribute(input, 'aria-autocomplete', 'list');
    setAttribute(input, 'aria-haspopup', 'listbox');

    var popup = getPopup(input);
    if (!popup) {
      setAttribute(input, 'aria-expanded', 'false');
      input.removeAttribute('aria-controls');
      input.removeAttribute('aria-activedescendant');
      return;
    }

    if (!popup.id) popup.id = input.id + '-listbox';
    setAttribute(popup, 'role', 'listbox');
    setAttribute(input, 'aria-controls', popup.id);
    setAttribute(
      input,
      'aria-expanded',
      popup.classList.contains('boost-pfs-search-suggestion-open') ? 'true' : 'false'
    );

    var selectedItem = popup.querySelector(itemSelector.split(',').map(function (selector) {
      return selector + '.selected';
    }).join(','));
    var activeOption = null;

    getOptions(popup).forEach(function (option, index) {
      setAttribute(option, 'role', 'option');
      if (!option.id) option.id = popup.id + '-option-' + index;

      var isSelected = Boolean(selectedItem && (
        selectedItem === option ||
        selectedItem.contains(option) ||
        option.contains(selectedItem)
      ));
      setAttribute(option, 'aria-selected', isSelected ? 'true' : 'false');
      if (isSelected) activeOption = option;

      var link = getOptionLink(option);
      if (link) setAttribute(link, 'tabindex', '-1');
    });

    if (activeOption) {
      setAttribute(input, 'aria-activedescendant', activeOption.id);
    } else {
      input.removeAttribute('aria-activedescendant');
    }

    if (!popup._greenpanComboboxObserver) {
      popup._greenpanComboboxObserver = new MutationObserver(function () {
        syncSemantics(input);
      });
      popup._greenpanComboboxObserver.observe(popup, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function scheduleSync(input) {
    window.requestAnimationFrame(function () {
      syncSemantics(input);
    });
    window.setTimeout(function () {
      syncSemantics(input);
    }, 150);
  }

  function enhanceMobileControls(root) {
    var panels = [];

    if (root.matches && root.matches(mobilePanelSelector)) panels.push(root);
    root.querySelectorAll(mobilePanelSelector).forEach(function (panel) {
      panels.push(panel);
    });

    panels.forEach(function (panel) {
      var closeButton = panel.querySelector('.boost-pfs-search-btn-close-suggestion');
      var clearButton = panel.querySelector('.boost-pfs-search-btn-clear-suggestion');

      if (closeButton) {
        setAttribute(closeButton, 'type', 'button');
        setAttribute(closeButton, 'aria-label', 'Close search');
      }

      if (clearButton) {
        setAttribute(clearButton, 'type', 'button');
        setAttribute(clearButton, 'aria-label', 'Clear search');
        clearButton.removeAttribute('role');
      }
    });
  }

  function initializeInputs() {
    enhanceMobileControls(document);
    document.querySelectorAll(inputSelector).forEach(function (input) {
      syncSemantics(input);
      window.setTimeout(function () {
        syncSemantics(input);
        enhanceMobileControls(document);
      }, 500);
    });
  }

  document.addEventListener('focusin', function (event) {
    if (event.target.matches('#boost-pfs-search-box-mobile')) {
      enhanceMobileControls(event.target.closest(mobilePanelSelector) || document);
    }
    if (event.target.matches(inputSelector)) scheduleSync(event.target);
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches(inputSelector)) scheduleSync(event.target);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.boost-pfs-search-btn-close-suggestion')) return;

    var openSearchModal = Array.from(
      document.querySelectorAll('[data-a11y-modal][aria-hidden="false"]')
    ).find(function (modal) {
      return modal.querySelector('input[name="boost-q"]');
    });
    var modalCloseButton = openSearchModal &&
      openSearchModal.querySelector('[data-a11y-modal-close]');
    if (!modalCloseButton) return;

    // Let Boost close its mobile suggestion panel first, then close the
    // underlying search dialog through its existing modal controller.
    window.setTimeout(function () {
      modalCloseButton.click();
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeInputs);
  } else {
    initializeInputs();
  }
})();
